import { Modal, message } from 'antd';
import { ColumnsType } from 'antd/lib/table';
import { floor, round, pickBy, keys, max } from 'lodash';
import { read, utils } from 'xlsx';
import { jsPDF } from 'jspdf';

import { deleteAttachFile } from '../api/constlink';
import { ContractType, contractType1Enum } from '../modules/contracts';
import { AssetType, Expense, InsertType } from '../modules/expenses';

export async function getUploadProps(
  enterpriseId: string,
  projectId: string,
  contractType1: ContractType,
  onSeccess?: (response: any) => void,
): Promise<any> {
  const accessToken = localStorage.getItem(
    process.env.REACT_APP_AUTH_TOKEN_NAME!,
  );
  const baseUrl = process.env.REACT_APP_API_ENDPOINT;
  const uploadUrl = `${baseUrl}/enterprises/${enterpriseId}/projects/${projectId}/${getContractSubUrl(
    contractType1,
  )}/attach-file`;
  const deleteUrl = `${baseUrl}/enterprises/${enterpriseId}/projects/${projectId}/${getContractSubUrl(
    contractType1,
  )}/attach-file`;

  const uploadProps = {
    name: 'file',
    action: uploadUrl, // antd Upload component send file data to server
    headers: {
      authorization: `Bearer ${accessToken}`,
    },
    multiple: true,
    onChange: (info: any) => {
      if (info.file.status !== 'uploading') {
      }
      if (info.file.status === 'done') {
        if (onSeccess !== undefined) onSeccess(info.file.response);
      } else if (info.file.status === 'error') {
        console.error(`${info.file.name} file upload failed.`);
      }
    },
    onRemove: async (file: any) => {
      let path;

      if ('path' in file) {
        path = file.path;
      } else {
        path = file.response.path;
      }
      let apiUrl: string = `${deleteUrl}?path=${path}`;
      await deleteAttachFile(apiUrl);
    },
  };
  return uploadProps;
}

export async function initializeUploadProps(
  subUrl: string,
  onSeccess?: (response: any) => void,
): Promise<any> {
  const accessToken = localStorage.getItem(
    process.env.REACT_APP_AUTH_TOKEN_NAME!,
  );
  const baseUrl = process.env.REACT_APP_API_ENDPOINT;
  // const uploadUrl = `${baseUrl}/projects/${projectId}/${getContractSubUrl(
  //   contractType1,
  // )}/attach-file`;
  // const deleteUrl = `${baseUrl}/projects/${projectId}/${getContractSubUrl(
  //   contractType1,
  // )}/attach-file`;

  const uploadProps = {
    name: 'file',
    // action: uploadUrl, // antd Upload component send file data to server
    action: `${baseUrl}/${subUrl}/upload`,
    headers: {
      authorization: `Bearer ${accessToken}`,
    },
    multiple: true,
    onChange: (info: any) => {
      if (info.file.status !== 'uploading') {
      }
      if (info.file.status === 'done') {
        if (onSeccess !== undefined) onSeccess(info.file.response);
      } else if (info.file.status === 'error') {
        console.error(`${info.file.name} file upload failed.`);
      }
    },
    onRemove: async (file: any) => {
      let path;

      if ('path' in file) {
        path = file.path;
      } else {
        path = file.response.path;
      }
      let apiUrl: string = `${baseUrl}/${subUrl}/delete?path=${path}`;
      await deleteAttachFile(apiUrl);
    },
  };
  return uploadProps;
}

export async function initializeUploadProps2(
  subUrl: string,
  onSeccess?: (response: any) => void,
): Promise<any> {
  const accessToken = localStorage.getItem(
    process.env.REACT_APP_AUTH_TOKEN_NAME!,
  );
  const baseUrl = process.env.REACT_APP_API_ENDPOINT;

  const uploadProps = {
    name: 'file',
    action: `${baseUrl}/${subUrl}/upload`,
    headers: {
      authorization: `Bearer ${accessToken}`,
    },
    multiple: true,
    // beforeUpload: (file: any) => {
    //   const isPDF = file.type === 'application/pdf';
    //   if (!isPDF) {
    //     message.error(
    //       `${file.name} 을 업로드 할 수 없습니다. PDF 파일만 업로드 가능합니다.`,
    //     );
    //   }
    //   return isPDF || Upload.LIST_IGNORE;
    // },
    beforeUpload: (file: any) => {
      return new Promise((resolve) => {
        const isPDF = file.type === 'application/pdf';
        if (!isPDF) {
          if (file.type === 'image/jpeg' || file.type === 'image/png') {
            const reader1 = new FileReader();
            reader1.readAsDataURL(file);
            const url = URL.createObjectURL(file);
            var doc = new jsPDF('p', 'mm', [297, 210]); // A4 size page of PDF
            const imgProps = doc.getImageProperties(url);
            const pdfWidth = doc.internal.pageSize.getWidth();
            const pdfHeight = (imgProps.height * pdfWidth) / imgProps.width;
            try {
              doc.addImage(
                url,
                file.type === 'image/jpeg' ? 'JPEG' : 'PNG',
                0,
                0,
                pdfWidth,
                pdfHeight,
                'FAST',
              );
            } catch (error) {
              console.log('error', error);
            }

            const reader = new FileReader();
            reader.readAsDataURL(doc.output('blob'));
            const myFile = new File(
              [doc.output('blob')],
              `${file.name.split('.')[0]}.pdf`,
              {
                type: 'application/pdf',
              },
            );
            resolve(myFile);
          } else {
            message.error(
              `${file.name} 을 업로드 할 수 없습니다. JPEG,PNG,PDF 파일만 업로드 가능합니다.`,
            );
            return false;
          }
        } else {
          resolve(file);
        }
      });
    },
    onChange: (info: any) => {
      if (info.file.status !== 'uploading') {
      }
      if (info.file.status === 'done') {
        if (onSeccess !== undefined) onSeccess(info.file.response);
      } else if (info.file.status === 'error') {
        console.error(`${info.file.name} file upload failed.`);
      }
    },
    onRemove: async (file: any) => {
      let path;

      if ('path' in file) {
        path = file.path;
      } else {
        path = file.response.path;
      }
      let apiUrl: string = `${baseUrl}/${subUrl}/delete?path=${path}`;
      await deleteAttachFile(apiUrl);
    },
  };
  return uploadProps;
}

export async function getSOVUploadProps(
  enterpriseId: string,
  projectId: string,
  contractId: string,
  contractType1: ContractType,
  subUrl?: string,
  onSeccess?: (response: any) => void,
): Promise<any> {
  const accessToken = localStorage.getItem(
    process.env.REACT_APP_AUTH_TOKEN_NAME!,
  );
  const baseUrl = process.env.REACT_APP_API_ENDPOINT;
  const uploadUrl = `${baseUrl}/enterprises/${enterpriseId}/projects/${projectId}/${getContractSubUrl(
    contractType1,
  )}/${contractId}${subUrl ? '/' + subUrl : ''}`;

  const uploadProps = {
    name: 'file',
    action: uploadUrl, // antd Upload component send file data to server
    accept:
      'application/vnd.ms-excel, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    headers: {
      authorization: `Bearer ${accessToken}`,
    },
    onChange: (info: any) => {
      if (info.file.status !== 'uploading') {
      }
      if (info.file.status === 'done') {
        if (onSeccess !== undefined) onSeccess(info.file.response);
      } else if (info.file.status === 'error') {
        console.error(`${info.file.name} file upload failed.`);
      }
    },
  };
  return uploadProps;
}

export const getContractSubUrl = (contractType1: ContractType) => {
  if (contractType1 === contractType1Enum.PRIME_CONTRACT)
    return 'prime-contracts';
  else if (
    contractType1 === contractType1Enum.SUBCONTRACT_WORK ||
    contractType1 === contractType1Enum.SUBCONTRACT_PURCHASE
  )
    return 'sub-contracts';
  else return 'None';
};

export const getPaymentSubUrl = (
  contractId?: string,
  directCostId?: string,
) => {
  if (!!contractId) return `sub-contracts/${contractId}`;
  else if (!!directCostId) return `direct-costs/${directCostId}`;
  else return 'None';
};

export function priceToString(price: number) {
  let result;

  if (price === 0) return '0';

  if (!price) return '0';
  result = isNaN(price)
    ? '0'
    : round(price)
        .toString()
        .replace(/\B(?=(\d{3})+(?!\d))/g, ',');

  return result;
}

export function priceFixedPointStr(price: number): string {
  let result: string;
  if (!price) return '0';
  result = isNaN(price) ? '0' : (price * 100).toFixed(1) + '';
  return result;
}

export function priceFixedPointStr2(price: number): string {
  let result: string;
  if (!price) return '0';
  result = isNaN(price) ? '0' : price.toFixed(1) + '';
  return result;
}

export function getPrimeContractFileAPIPath(
  enterpriseId: string,
  projectId: string,
) {
  return `enterprises/${enterpriseId}/projects/${projectId}/prime-contracts/attach-file`;
}

export function getSubContractFileAPIPath(
  enterpriseId: string,
  projectId: string,
) {
  return `enterprises/${enterpriseId}/projects/${projectId}/sub-contracts/attach-file`;
}

export function getBidPackageFileAPIPath(
  enterpriseId: string,
  projectId: string,
) {
  return `enterprises/${enterpriseId}/projects/${projectId}/bid-packages/attach-file`;
}

export function getPCCOFileAPIPath(
  enterpriseId: string,
  projectId: string,
  contractId: string,
) {
  return `enterprises/${enterpriseId}/projects/${projectId}/prime-contracts/${contractId}/change-orders/attach-file`;
}

export function getSCCOFileAPIPath(
  enterpriseId: string,
  projectId: string,
  contractId: string,
) {
  return `enterprises/${enterpriseId}/projects/${projectId}/sub-contracts/${contractId}/change-orders/attach-file`;
}

export function getSCInvoiceFileAPIPath(
  enterpriseId: string,
  projectId: string,
  contractId: string,
) {
  return `enterprises/${enterpriseId}/projects/${projectId}/sub-contracts/${contractId}/invoices/attach-file`;
}

export function getDirectCostFileAPIPath(
  enterpriseId: string,
  projectId: string,
) {
  return `enterprises/${enterpriseId}/projects/${projectId}/direct-costs/attach-file`;
}

export function getProjectSharedFileAPIPath(
  enterpriseId: string,
  projectId: string,
) {
  return `enterprises/${enterpriseId}/projects/${projectId}/attach-file`;
}

export function getBidChanceSharedFileAPIPath(bidChanceId: string) {
  return `bid-chances/${bidChanceId}/attach-file`;
}

export function getEmailInvitationFileAPIPath(
  enterpriseId: string,
  bidChanceId: string,
) {
  return `enterprises/${enterpriseId}/bid-chances/${bidChanceId}/attach-file`;
}

export function getBidProposalFileAPIPath(bidChanceId: string) {
  return `bid-chances/${bidChanceId}/bid-proposals/attach-file`;
}

export function getEnterpriseLogoFileAPIPath(enterpriseId: string) {
  return `enterprises/${enterpriseId}/attach-file`;
}

export function getVendorFileAPIPath(enterpriseId: string) {
  return `enterprises/${enterpriseId}/vendors/attach-file`;
}

export function getVendorApplyFileAPIPath(enterpriseId: string) {
  return `enterprises/${enterpriseId}/vendors/apply/attach-file`;
}

export function getInvoiceFileAPIPath(
  enterpriseId: string,
  projectId?: string,
) {
  let url = `enterprises/${enterpriseId}`;
  if (projectId) url += `/projects/${projectId}/invoices/attach-file`;
  else url += `/invoices/attach-file`;
  return url;
}

export function getExpenseFileAPIPath(
  enterpriseId: string,
  projectId?: string,
) {
  let url = `enterprises/${enterpriseId}`;
  if (projectId) url += `/projects/${projectId}/expenses/attach-file`;
  else url += `/expenses/attach-file`;
  return url;
}

export function getWorkRecordFileAPIPath(
  enterpriseId: string,
  projectId: string,
) {
  return `enterprises/${enterpriseId}/projects/${projectId}/work-records/attach-file`;
}

export function getTaskFileAPIPath(enterpriseId: string, projectId: string) {
  return `enterprises/${enterpriseId}/projects/${projectId}/tasks/attach-file`;
}

export const genLevel1CodeList = (
  data: any[],
  topConstructionCodeLevel: any,
) => {
  const level1CodeList: any[] = data
    .filter((item: any) => item.level === topConstructionCodeLevel)
    .map((item: any) => {
      return {
        id: item.id,
        name: item.name,
        code: item.code,
      };
    });

  return level1CodeList;
};

export const genLevel1Data = (data: any[], topConstructionCodeLevel: any) => {
  const level1CodeList: any[] = data
    .filter((item: any) => item.level === topConstructionCodeLevel)
    .map((item: any) => {
      return {
        id: item.id,
        name: item.name,
        code: item.code,
      };
    });

  const _level1Data: any[] = level1CodeList.map((code) => {
    const tempData: any[] = data.filter((item: any) =>
      item.code.startsWith(code.code),
    );

    let materialCost = 0,
      materialCostTotal = 0,
      laborCost = 0,
      laborCostTotal = 0,
      expense = 0,
      expenseTotal = 0,
      totalUnitCost = 0,
      total = 0;
    for (const temp of tempData) {
      materialCost += temp.materialCost;
      materialCostTotal += temp.materialCostTotal;

      laborCost += temp.laborCost;
      laborCostTotal += temp.laborCostTotal;

      expense += temp.expense;
      expenseTotal += temp.expenseTotal;

      totalUnitCost += temp.totalUnitCost;
      total += temp.total;
    }
    return {
      id: code.id,
      editable: true,
      code: code.code,
      name: code.name,
      materialCost,
      materialCostTotal,
      laborCost,
      laborCostTotal,
      expense,
      expenseTotal,
      totalUnitCost,
      total,
    };
  });
  return _level1Data;
};

export const genLevel2Data = (
  data: any[],
  projectName: string,
  level1CodeList: any[],
) => {
  const _level2Data: any[] = level1CodeList.map((code1) => {
    const level2CodeList: any[] = data
      .filter(
        (item: any) => item.level === 2 && item.code.startsWith(code1.code),
      )
      .map((item: any) => {
        return {
          id: item.id,
          name: item.name,
          code: item.code,
        };
      });

    const tempArr = [];
    for (const code2 of level2CodeList) {
      const tempData = data.filter((item: any) =>
        item.code.startsWith(code2.code),
      );
      let materialCost = 0,
        materialCostTotal = 0,
        laborCost = 0,
        laborCostTotal = 0,
        expense = 0,
        expenseTotal = 0,
        totalUnitCost = 0,
        total = 0;
      for (const temp of tempData) {
        materialCost += temp.materialCost;
        materialCostTotal += temp.materialCostTotal;

        laborCost += temp.laborCost;
        laborCostTotal += temp.laborCostTotal;

        expense += temp.expense;
        expenseTotal += temp.expenseTotal;

        totalUnitCost += temp.totalUnitCost;
        total += temp.total;
      }
      tempArr.push({
        id: code2.id,
        editable: true,
        code: code2.code,
        name: code2.name,
        materialCost,
        materialCostTotal,
        laborCost,
        laborCostTotal,
        expense,
        expenseTotal,
        totalUnitCost,
        total,
      });
    }
    return {
      projectName: `${projectName}(${code1.name})`,
      items: tempArr,
    };
  });
  return _level2Data;
};

export const genLevel3Data = (
  data: any[],
  projectName: string,
  level1CodeList: any[],
) => {
  const tempArr: any[] = [];
  level1CodeList.forEach((code1) => {
    const level2CodeList: any[] = data
      .filter(
        (item: any) => item.level === 2 && item.code.startsWith(code1.code),
      )
      .map((item: any) => {
        return {
          id: item.id,
          name: item.name,
          code: item.code,
        };
      });

    for (const code2 of level2CodeList) {
      const tempData = data
        .filter((item: any) => item.code.startsWith(code2.code))
        .map((item: any) => {
          return {
            id: item.id,
            editable: item.editable,
            code: item.code,
            standard: item.standard,
            unit: item.unit,
            quantity: item.quantity,
            name: item.name,
            materialCost: item.materialCost,
            materialCostTotal: item.materialCostTotal,
            laborCost: item.laborCost,
            laborCostTotal: item.laborCostTotal,
            expense: item.expense,
            expenseTotal: item.expenseTotal,
            totalUnitCost: item.totalUnitCost,
            total: item.total,
          };
        });
      tempArr.push({
        projectName: `${projectName}(${code1.name})`,
        items: tempData,
      });
    }
  });
  return tempArr;
};

export const genTableData = (newData: any[]) => {
  for (let index = 0; index < newData.length; index++) {
    calcTotal(newData, index);
  }

  return newData;
};

export const calcTotal = (data: any, index: any) => {
  const _quantity = !!data[index]['quantity'] ? data[index]['quantity'] : 0;
  const _materialCost = !!data[index]['materialCost']
    ? data[index]['materialCost']
    : 0;
  const _laborCost = !!data[index]['laborCost'] ? data[index]['laborCost'] : 0;
  const _expense = !!data[index]['expense'] ? data[index]['expense'] : 0;
  data[index]['materialCostTotal'] = +(_materialCost * _quantity).toFixed(12);
  data[index]['laborCostTotal'] = +(_laborCost * _quantity).toFixed(12);
  data[index]['expenseTotal'] = +(_expense * _quantity).toFixed(12);
  data[index]['total'] =
    data[index]['materialCostTotal'] +
    data[index]['laborCostTotal'] +
    data[index]['expenseTotal'];
  data[index]['totalUnitCost'] =
    data[index]['materialCost'] +
    data[index]['laborCost'] +
    data[index]['expense'];
};

/*
export const genCostAccountingTableObj = (data: any, contract?: Contract) => {
  const _costAccountingTableObj: any = {};

  _costAccountingTableObj.laborCostTotal = data.items.reduce(function (
    pre: any,
    next: any,
  ) {
    return pre + next.laborCostTotal;
  },
  0);

  _costAccountingTableObj.materialCostTotal = data.items.reduce(function (
    pre: any,
    next: any,
  ) {
    return pre + next.materialCostTotal;
  },
  0);

  _costAccountingTableObj.expenseTotal = data.items.reduce(function (
    pre: any,
    next: any,
  ) {
    return pre + next.expenseTotal;
  },
  0);

  _costAccountingTableObj.value0 =
    (_costAccountingTableObj.laborCostTotal *
      contract?.metaData.costAccountingSheetRate0!) /
    100;

  // _costAccountingTableObj.laborCostTotal =
  //   data.items[0].laborCostTotal + _costAccountingTableObj.value0;

  // FIXME: 간접재료비, 작업설, 부산물이 빠져 있음.
  // _costAccountingTableObj.materialCostTotal = data.items[0].materialCostTotal;

  // _costAccountingTableObj.expense = data.items[0].expenseTotal;

  _costAccountingTableObj.value1 =
    (_costAccountingTableObj.laborCostTotal *
      contract?.metaData.costAccountingSheetRate1!) /
    100;

  _costAccountingTableObj.value2 =
    (_costAccountingTableObj.laborCostTotal *
      contract?.metaData.costAccountingSheetRate2!) /
    100;

  _costAccountingTableObj.value3 =
    (_costAccountingTableObj.laborCostTotal *
      contract?.metaData.costAccountingSheetRate3!) /
    100;

  _costAccountingTableObj.value4 =
    (_costAccountingTableObj.laborCostTotal *
      contract?.metaData.costAccountingSheetRate4!) /
    100;

  _costAccountingTableObj.value5 =
    (_costAccountingTableObj.value3 *
      contract?.metaData.costAccountingSheetRate5!) /
    100;

  _costAccountingTableObj.value6 =
    (_costAccountingTableObj.laborCostTotal *
      contract?.metaData.costAccountingSheetRate6!) /
    100;

  // FIXME: 관급자재비,기초값 빠져 있음
  _costAccountingTableObj.value7 =
    (((_costAccountingTableObj.materialCostTotal +
      _costAccountingTableObj.laborCostTotal) *
      contract?.metaData.costAccountingSheetRate7!) /
      100) *
    1.2;

  _costAccountingTableObj.value8 =
    ((_costAccountingTableObj.laborCostTotal +
      _costAccountingTableObj.materialCostTotal) *
      contract?.metaData.costAccountingSheetRate8!) /
    100;

  _costAccountingTableObj.value9 =
    ((_costAccountingTableObj.materialCostTotal +
      _costAccountingTableObj.laborCostTotal +
      _costAccountingTableObj.expense) *
      contract?.metaData.costAccountingSheetRate9!) /
    100;

  _costAccountingTableObj.value10 =
    ((_costAccountingTableObj.materialCostTotal +
      _costAccountingTableObj.laborCostTotal +
      _costAccountingTableObj.expense) *
      contract?.metaData.costAccountingSheetRate10!) /
    100;

  // 건설기계대여금지급보증서발급수수료 요율
  _costAccountingTableObj.value11 =
    ((_costAccountingTableObj.materialCostTotal +
      _costAccountingTableObj.laborCostTotal +
      _costAccountingTableObj.expense) *
      contract?.metaData.costAccountingSheetRate11!) /
    100;

  // FIXME: 운반비 빠져 있음
  // _costAccountingTableObj.expenseTotal =
  //   _costAccountingTableObj.expense +
  //   _costAccountingTableObj.value1 +
  //   _costAccountingTableObj.value2 +
  //   _costAccountingTableObj.value3 +
  //   _costAccountingTableObj.value4 +
  //   _costAccountingTableObj.value5 +
  //   _costAccountingTableObj.value6 +
  //   _costAccountingTableObj.value7 +
  //   _costAccountingTableObj.value8 +
  //   _costAccountingTableObj.value9 +
  //   _costAccountingTableObj.value10 +
  //   _costAccountingTableObj.value11;

  _costAccountingTableObj.subTotal =
    _costAccountingTableObj.laborCostTotal +
    _costAccountingTableObj.materialCostTotal +
    _costAccountingTableObj.expenseTotal;

  _costAccountingTableObj.administrativExpense =
    (_costAccountingTableObj.subTotal *
      contract?.metaData.costAccountingSheetRate12!) /
    100;

  _costAccountingTableObj.profit =
    ((_costAccountingTableObj.laborCostTotal +
      _costAccountingTableObj.expenseTotal +
      _costAccountingTableObj.administrativExpense) *
      contract?.metaData.costAccountingSheetRate13!) /
    100;

  _costAccountingTableObj.supplyPrice =
    _costAccountingTableObj.subTotal +
    _costAccountingTableObj.administrativExpense +
    _costAccountingTableObj.profit;

  _costAccountingTableObj.VAT =
    (_costAccountingTableObj.supplyPrice * 10) / 100;

  _costAccountingTableObj.contractPrice =
    _costAccountingTableObj.supplyPrice + _costAccountingTableObj.VAT;

  // FIXME: 관급자재비 빠져 있음
  _costAccountingTableObj.totalPrice = _costAccountingTableObj.contractPrice;
  return _costAccountingTableObj;
};
*/

export const genCostAccountingTableObj2 = (sov: any, metaData: any) => {
  const _costAccountingTableObj: any = {};

  _costAccountingTableObj.directLaborCost = 0;
  for (let i = 0; i < sov.length; i++) {
    _costAccountingTableObj.directLaborCost +=
      +sov[i].laborCostTotal.toFixed(12);
  }

  _costAccountingTableObj.directMaterialCost = 0;
  for (let i = 0; i < sov.length; i++) {
    _costAccountingTableObj.directMaterialCost +=
      +sov[i].materialCostTotal.toFixed(12);
  }

  _costAccountingTableObj.directExpense = 0;
  for (let i = 0; i < sov.length; i++) {
    _costAccountingTableObj.directExpense += +sov[i].expenseTotal.toFixed(12);
  }

  // 간접 노무비 (원)
  _costAccountingTableObj.value0 = round(
    +(
      (_costAccountingTableObj.directLaborCost *
        metaData.costAccountingSheetRate0) /
      100
    ).toFixed(12),
  );

  // 산재보험료 (원)
  _costAccountingTableObj.value1 = round(
    +(
      ((_costAccountingTableObj.directLaborCost +
        _costAccountingTableObj.value0) *
        metaData.costAccountingSheetRate1!) /
      100
    ).toFixed(12),
  );

  // 고용보험료 (원)
  _costAccountingTableObj.value2 = round(
    +(
      ((_costAccountingTableObj.directLaborCost +
        _costAccountingTableObj.value0) *
        metaData.costAccountingSheetRate2!) /
      100
    ).toFixed(12),
  );

  // 국민건강보험료 (원)
  _costAccountingTableObj.value3 = round(
    +(
      (_costAccountingTableObj.directLaborCost *
        metaData.costAccountingSheetRate3!) /
      100
    ).toFixed(12),
  );

  // 국민연금보험료 (원)
  _costAccountingTableObj.value4 = round(
    +(
      (_costAccountingTableObj.directLaborCost *
        metaData.costAccountingSheetRate4!) /
      100
    ).toFixed(12),
  );

  // 노인장기요양보험료 (원)
  _costAccountingTableObj.value5 = round(
    +(
      (_costAccountingTableObj.value3 * metaData.costAccountingSheetRate5!) /
      100
    ).toFixed(12),
  );

  // 퇴직공제부금비 (원)
  _costAccountingTableObj.value6 = round(
    +(
      (_costAccountingTableObj.directLaborCost *
        metaData.costAccountingSheetRate6!) /
      100
    ).toFixed(12),
  );

  // 산업안전보건관리비 (원)
  // FIXME: 관급자재비,기초값 빠져 있음
  _costAccountingTableObj.value7 =
    round(
      +(
        ((_costAccountingTableObj.directMaterialCost +
          _costAccountingTableObj.directLaborCost) *
          metaData.costAccountingSheetRate7!) /
        100
      ).toFixed(12),
    ) + metaData.costAccountingSheetBasePrice7;

  // 기타 경비 (원)
  _costAccountingTableObj.value8 = round(
    +(
      ((_costAccountingTableObj.directLaborCost +
        _costAccountingTableObj.value0 +
        _costAccountingTableObj.directMaterialCost) *
        metaData.costAccountingSheetRate8!) /
      100
    ).toFixed(12),
  );

  // 환경보전비 (원)
  _costAccountingTableObj.value9 = round(
    +(
      ((_costAccountingTableObj.directMaterialCost +
        _costAccountingTableObj.directLaborCost +
        _costAccountingTableObj.directExpense) *
        metaData.costAccountingSheetRate9!) /
      100
    ).toFixed(12),
  );

  // 건설하도급대금지급보증서발급수수료 (원)
  _costAccountingTableObj.value10 = round(
    +(
      ((_costAccountingTableObj.directMaterialCost +
        _costAccountingTableObj.directLaborCost +
        _costAccountingTableObj.directExpense) *
        metaData.costAccountingSheetRate10!) /
      100
    ).toFixed(12),
  );

  // 건설기계대여금지급보증서발급수수료 (원)
  _costAccountingTableObj.value11 = round(
    +(
      ((_costAccountingTableObj.directMaterialCost +
        _costAccountingTableObj.directLaborCost +
        _costAccountingTableObj.directExpense) *
        metaData.costAccountingSheetRate11!) /
      100
    ).toFixed(12),
  );

  // 재료비 소계
  _costAccountingTableObj.materialCostTotal =
    _costAccountingTableObj.directMaterialCost;

  // 노무비 소계
  _costAccountingTableObj.laborCostTotal =
    _costAccountingTableObj.directLaborCost + _costAccountingTableObj.value0;

  // 경비 소계
  // FIXME: 운반비 빠져 있음
  _costAccountingTableObj.expenseTotal =
    _costAccountingTableObj.directExpense +
    _costAccountingTableObj.value1 +
    _costAccountingTableObj.value2 +
    _costAccountingTableObj.value3 +
    _costAccountingTableObj.value4 +
    _costAccountingTableObj.value5 +
    _costAccountingTableObj.value6 +
    _costAccountingTableObj.value7 +
    _costAccountingTableObj.value8 +
    _costAccountingTableObj.value9 +
    _costAccountingTableObj.value10 +
    _costAccountingTableObj.value11;

  // 계
  _costAccountingTableObj.subTotal =
    _costAccountingTableObj.laborCostTotal +
    _costAccountingTableObj.materialCostTotal +
    _costAccountingTableObj.expenseTotal;

  // 일반관리비 (원)
  _costAccountingTableObj.administrativExpense = round(
    +(
      (_costAccountingTableObj.subTotal * metaData.costAccountingSheetRate12!) /
      100
    ).toFixed(12),
  );

  // 이윤 (원)
  _costAccountingTableObj.profit = round(
    +(
      ((_costAccountingTableObj.laborCostTotal +
        _costAccountingTableObj.expenseTotal +
        _costAccountingTableObj.administrativExpense) *
        metaData.costAccountingSheetRate13!) /
      100
    ).toFixed(12),
  );

  // 공급가액(총공사원가)
  _costAccountingTableObj.supplyPrice =
    _costAccountingTableObj.subTotal +
    _costAccountingTableObj.administrativExpense +
    _costAccountingTableObj.profit;

  // 부가세
  _costAccountingTableObj.VAT = round(
    +(
      (_costAccountingTableObj.supplyPrice *
        metaData.costAccountingSheetRate14!) /
      100
    ).toFixed(12),
  );

  // 총도급원가
  _costAccountingTableObj.contractPrice =
    _costAccountingTableObj.supplyPrice + _costAccountingTableObj.VAT;

  // 총공사비
  // FIXME: 관급자재비 빠져 있음
  _costAccountingTableObj.totalPrice = _costAccountingTableObj.contractPrice;
  return _costAccountingTableObj;
};

function getDataRange(data: any) {
  const dataWithValues = pickBy(data, (value, key) => !!value.v);
  const cellNamesWithValues = keys(dataWithValues);
  const cellsWithValues = cellNamesWithValues.map((cell) =>
    utils.decode_cell(cell),
  );
  const maxRow: any = max(cellsWithValues.map((cell) => cell.r));
  const maxColumn: any = max(cellsWithValues.map((cell) => cell.c));
  const lastCellName = utils.encode_cell({ c: maxColumn, r: maxRow });
  return `A1:${lastCellName}`;
}

export const onLoadContractSOV = async (
  fileData: any,
  projectId: string,
  contractType1: ContractType,
) => {
  const wb = read(fileData, { type: 'binary' });
  const sheetNames = wb.SheetNames;
  const results: any = {
    data: [],
    errors: [],
  };

  if (
    contractType1 !== contractType1Enum.PRIME_CONTRACT &&
    sheetNames.length > 1
  ) {
    Modal.error({
      content: '하도급 계약은 1개의 시트만 업로드할 수 있습니다.',
    });
    return null;
  }

  for (let i = 0; i < sheetNames.length; i++) {
    const sheet = wb.Sheets[sheetNames[i]];
    sheet['!ref'] = getDataRange(sheet);
    const sheetRows: any[] = utils.sheet_to_json(sheet);
    let index = 0;
    for (const row of sheetRows) {
      const level = row['레벨'];
      const name = row['품명'];

      if (typeof level !== 'number' || typeof name !== 'string') {
        results.errors.push({
          sheetName: sheetNames[i],
          index,
        });
      }
      index += 1;
    }
  }

  if (results.errors.length > 0) {
    Modal.error({
      content: '업로드 파일이 잘못 되었습니다.',
    });
    return null;
  }

  for (let i = 0; i < sheetNames.length; i++) {
    const sheet = wb.Sheets[sheetNames[i]];
    sheet['!ref'] = getDataRange(sheet);
    const sheetRows: any[] = utils.sheet_to_json(sheet);
    results.data.push({
      project: { id: +projectId },
      name: sheetNames[i],
      level: 1,
      standard: '',
      unit: '',
      code: '',
    });

    for (const row of sheetRows) {
      const level = row['레벨'] ? row['레벨'] : 1;
      const name = row['품명'] ? row['품명'] : '';
      const standard = row['규격'] ? row['규격'] : '';
      const unit = row['단위'] ? row['단위'] : '';

      const quantity = row['수량'] ? row['수량'] : 0;
      const materialCost = row['재료비 단가'] ? row['재료비 단가'] : 0;
      const laborCost = row['노무비 단가'] ? row['노무비 단가'] : 0;
      const expense = row['경비 단가'] ? row['경비 단가'] : 0;
      const total =
        floor(laborCost * quantity) +
        floor(materialCost * quantity) +
        floor(expense * quantity);

      results.data.push({
        project: { id: +projectId },
        level: level + 1,
        name,
        standard,
        unit,
        code: '',
        sov: {
          quantity,
          materialCost,
          laborCost,
          expense,
          total,
        },
      });
    }
  }

  if (results.data.length === 0) {
    Modal.error({
      content: '업로드 파일의 내용이 없습니다.',
    });
    return null;
  }
  return results.data;
};

export const parseContractSovXlsxFile = async (
  fileData: any,
  projectId: string,
  contractId: string,
  contractType1: ContractType,
) => {
  const allowedSheetNames = ['토목', '건축', '설비', '전기'];
  const wb = read(fileData, { type: 'binary' });
  const sheetNames = wb.SheetNames;
  const results: any = {
    data: [],
    errors: [],
  };

  if (contractType1 !== contractType1Enum.PRIME_CONTRACT) {
    if (sheetNames.length > 1) {
      Modal.error({
        content: '하도급 계약은 1개의 시트만 업로드할 수 있습니다.',
      });
      return null;
    }

    if (allowedSheetNames.includes(sheetNames[0]) === false) {
      Modal.error({
        content: `${sheetNames[0]} 는 잘못된 Sheet 이름 입니다. Sheet 이름은 토목, 건축, 설비, 전기 중 하나 이어야 합니다.`,
      });
      return null;
    }
  } else {
    for (let i = 0; i < sheetNames.length; i++) {
      if (allowedSheetNames.includes(sheetNames[i]) === false) {
        Modal.error({
          content: `${sheetNames[i]} 는 잘못된 Sheet 이름 입니다. Sheet 이름은 토목, 건축, 설비, 전기 중 하나 이어야 합니다.`,
        });
        return null;
      }
    }
  }

  /*
  for (let i = 0; i < sheetNames.length; i++) {
    const sheet = wb.Sheets[sheetNames[i]];
    sheet['!ref'] = getDataRange(sheet);
    const sheetRows: any[] = utils.sheet_to_json(sheet);
    let index = 0;
    for (const row of sheetRows) {
      const level = row['레벨'];
      const name = row['품명'];

      if (typeof level !== 'number' || typeof name !== 'string') {
        results.errors.push({
          sheetName: sheetNames[i],
          index,
        });
      }
      index += 1;
    }
  }
  */

  if (results.errors.length > 0) {
    Modal.error({
      content: '업로드 파일이 잘못 되었습니다.',
    });
    return null;
  }

  for (let i = 0; i < sheetNames.length; i++) {
    const sheet = wb.Sheets[sheetNames[i]];
    sheet['!ref'] = getDataRange(sheet);
    const sheetRows: any[] = utils.sheet_to_json(sheet);
    results.data.push({
      project: { id: +projectId },
      contract: { id: +contractId },
      name: sheetNames[i],
      level: 1,
      standard: '',
      unit: '',
      code: '',
    });

    for (const row of sheetRows) {
      const level = row['레벨'];
      // const name = row['품명'];
      // const standard = row['규격'];
      // const unit = row['단위'];
      const name = row['품명'] ? row['품명'] : '';
      const standard = row['규격'] ? row['규격'] : '';
      const unit = row['단위'] ? row['단위'] : '';

      // const quantity = row['수량'];
      // const materialCost = row['재료비 단가'];
      // const laborCost = row['노무비 단가'];
      // const expense = row['경비 단가'];
      const quantity = row['수량'] ? +row['수량'].toFixed(12) : 0;
      // const materialCost = row['재료비 단가'] ? row['재료비 단가'] : 0;
      // const laborCost = row['노무비 단가'] ? row['노무비 단가'] : 0;
      // const expense = row['경비 단가'] ? row['경비 단가'] : 0;
      const materialCost = row['재료비 단가']
        ? row['재료비 단가']
        : row['재료비 금액']
        ? row['재료비 금액'] / row['수량']
        : 0;
      const laborCost = row['노무비 단가'] ? row['노무비 단가'] : 0;
      const expense = row['경비 단가'] ? row['경비 단가'] : 0;

      if (level === undefined) continue;

      // if (materialCost === undefined)
      // if (name !== undefined && standard !== undefined && unit !== undefined)

      // const total =
      // (laborCost * quantity) +
      // (materialCost * quantity) +
      // (expense * quantity);
      const total =
        +(laborCost + materialCost + expense).toFixed(12) * quantity;

      let editable = true;
      if (name !== '' && standard === '' && unit === '') editable = false;

      let sovId: number = 0;
      results.data.push({
        id: sovId++,
        project: { id: +projectId },
        contract: { id: +contractId },
        level: level + 1,
        name,
        standard,
        unit,
        code: '',
        editable,
        quantity,
        materialCost,
        laborCost,
        expense,
        total,
      });
    }
  }

  if (results.data.length === 0) {
    Modal.error({
      content: '업로드 파일의 내용이 없습니다.',
    });
    return null;
  }
  for (let i = 1; i < results.data.length + 1; i++) {
    results.data[i - 1].id = i;
  }

  return results.data;
};

export const createPrimeContractSovCode = async (sov: any) => {
  const originData = [...sov];

  // config parent id
  for (let i = 1; i < originData.length; i++) {
    if (originData[i].level > originData[i - 1].level) {
      originData[i].parentId = originData[i - 1].id;
    } else if (originData[i].level === originData[i - 1].level) {
      originData[i].parentId = originData[i - 1].parentId;
    } else if (originData[i].level < originData[i - 1].level) {
      const filteredData = originData.filter(
        (d) => d.id < originData[i].id && d.level === originData[i].level - 1,
      );
      originData[i].parentId = filteredData[filteredData.length - 1]?.id;
    }
  }

  const levelArr: number[] = [1, 2, 3, 4, 5, 6];
  levelArr.map((k: number) => {
    let n = 0;
    let _code: any;
    let topLevelNum = 0;
    originData
      .filter((data) => data.level === k)
      .map((d: any, i: any, arr: any[]) => {
        if (d.parentId !== arr[i - 1]?.parentId) {
          n = 0;
        }
        if (k === 1) _code = '' + topLevelNum++;
        else {
          for (let j = 0; j < originData.length; j++) {
            if (originData[j].id === d.parentId) {
              _code = originData[j].code + '-' + n++;
            }
          }
        }
        d.code = _code;
        return d;
      });
    return null;
  });

  for (let i = 0; i < originData.length; i++) {
    delete originData[i].id;
  }

  return originData;
};

export const createSubContractSovCode = async (
  uploadedSOV: any,
  prevSOV: any,
) => {
  const originData = [...uploadedSOV];
  let parentSovCode: string = '';
  let initialSovCode: string;
  let lastParentPrevSovNum: number = -1;
  const parentSovName = originData[0].name;

  for (let i = 0; i < prevSOV.length; i++) {
    if (prevSOV[i].name === parentSovName) {
      parentSovCode = prevSOV[i].code.split('-')[0];
      break;
    }
  }

  if (parentSovCode !== '') {
    originData.splice(0, 1);
    for (let i = 0; i < prevSOV.length; i++) {
      if (prevSOV[i].code.startsWith(parentSovCode)) lastParentPrevSovNum = i;
    }
    if (lastParentPrevSovNum === -1)
      throw new Error('lastParentPrevSovNum is not found.');
    initialSovCode =
      parentSovCode +
      '-' +
      (+prevSOV[lastParentPrevSovNum].code.split('-')[1] + 1);
  } else {
    if (prevSOV.length === 0) initialSovCode = '';
    else {
      initialSovCode = `${+prevSOV[prevSOV.length - 1].code.split('-')[0] + 1}`;
    }
  }

  // config parent id
  for (let i = 1; i < originData.length; i++) {
    if (originData[i].level > originData[i - 1].level) {
      originData[i].parentId = originData[i - 1].id;
    } else if (originData[i].level === originData[i - 1].level) {
      originData[i].parentId = originData[i - 1].parentId;
    } else if (originData[i].level < originData[i - 1].level) {
      const filteredData = originData.filter(
        (d) => d.id < originData[i].id && d.level === originData[i].level - 1,
      );
      originData[i].parentId = filteredData[filteredData.length - 1]?.id;
    }
  }

  if (prevSOV.length !== 0) {
    for (const _sov of prevSOV) {
      if ('parentId' in _sov) continue;
      const _parentSov = prevSOV.find(
        (data: any) => data.level === 1 && data.name === parentSovName,
      );
      if (_parentSov) _sov.parentId = _parentSov.id;
    }
  }

  const levelArr: number[] = [1, 2, 3, 4, 5, 6];
  levelArr.map((k: number) => {
    let n = 0;
    let _code: any;
    let topLevelNum = 0;
    originData
      .filter((data) => data.level === k)
      .map((d: any, i: any, arr: any[]) => {
        let isExisted: boolean = false;
        if (d.parentId !== arr[i - 1]?.parentId) {
          n = 0;
        }
        if (k === 1) {
          if (initialSovCode.length === 0) {
            _code = '' + topLevelNum++;
          } else {
            _code = initialSovCode;
          }
        } else {
          for (let j = 0; j < originData.length; j++) {
            if (originData[j].id === d.parentId) {
              _code = originData[j].code + '-' + n++;
              isExisted = true;
            }
          }
          if (isExisted === false) _code = initialSovCode;
        }
        d.code = _code;
        return d;
      });
    return null;
  });

  for (let i = 0; i < originData.length; i++) {
    delete originData[i].id;
  }

  return originData;
};

export const s2ab = (s: any) => {
  const buf = new ArrayBuffer(s.length);
  var view = new Uint8Array(buf);
  for (var i = 0; i < s.length; i++) view[i] = s.charCodeAt(i) & 0xff;
  return buf;
};

export const checkPersonalPhoneNumber = (value: string) => {
  // '-' 입력 시
  // var regExp = /^01(?:0|1|[6-9])-(?:\d{3}|\d{4})-\d{4}$/
  // 숫자만 입력시
  // var regExp2 = /^01(?:0|1|[6-9])(?:\d{3}|\d{4})\d{4}$/;
  // 휴대전화
  // var regExp = /^\d{3}-\d{3,4}-\d{4}$/;
  const regExp = /^\d{3}\d{3,4}\d{4}$/;

  if (value === undefined || value === '') return Promise.resolve();

  if (regExp.test(value)) {
    return Promise.resolve();
  }
  return Promise.reject(new Error('유효하지 않은 전화번호 입니다.'));
};

export const checkGeneralPhoneNumber = (value: string) => {
  // const regExp = /^\d{2,3}-\d{3,4}-\d{4}$/;

  // FIXME: 일단 에러 발생하지 않도록 해둠. 수정 필요
  const regExp = /^\d{9,13}$/;

  if (value === undefined || value === '' || value === null)
    return Promise.resolve();

  if (regExp.test(value)) {
    return Promise.resolve();
  }
  return Promise.reject(new Error('유효하지 않은 전화번호 입니다.'));
};

export const checkCorporateNumber = (value: string) => {
  const regExp = /^\d{3}\d{2}\d{5}$/;

  if (value === undefined || value === '') return Promise.resolve();

  if (regExp.test(value)) {
    return Promise.resolve();
  }
  return Promise.reject(new Error('유효하지 않은 사업자등록번호 입니다.'));
};

export const contractSovColumns: ColumnsType<any> = [
  {
    title: '코드',
    dataIndex: ['code'],
    width: '10%',
  },
  {
    title: '품명',
    dataIndex: ['name'],
    width: '14%',
  },
  {
    title: '규격',
    dataIndex: ['standard'],
    width: '12%',
  },
  {
    title: '단위',
    dataIndex: ['unit'],
    width: '4%',
  },
  {
    title: '수량',
    dataIndex: 'quantity',
    width: '8%',
    render: (_, record: any) =>
      record.editable ? priceToString(record.quantity) : null,
  },
  {
    title: '재료비',
    children: [
      {
        title: '단가',
        dataIndex: 'materialCost',
        width: '8%',
        render: (_, record: any) =>
          record.editable ? priceToString(record.materialCost) : null,
      },
      {
        title: '합계',
        dataIndex: 'materialCostTotal',
        width: '10%',
        render: (_, record: any) =>
          record.editable ? priceToString(record.materialCostTotal) : null,
      },
    ],
  },
  {
    title: '노무비',
    children: [
      {
        title: '단가',
        dataIndex: 'laborCost',
        width: '8%',
        render: (_, record: any) =>
          record.editable ? priceToString(record.laborCost) : null,
      },
      {
        title: '합계',
        dataIndex: 'laborCostTotal',
        width: '10%',
        render: (_, record: any) =>
          record.editable ? priceToString(record.laborCostTotal) : null,
      },
    ],
  },
  {
    title: '경비',
    children: [
      {
        title: '단가',
        dataIndex: 'expense',
        width: '8%',
        render: (_, record: any) =>
          record.editable ? priceToString(record.expense) : null,
      },
      {
        title: '합계',
        dataIndex: 'expenseTotal',
        width: '10%',
        render: (_, record: any) =>
          record.editable ? priceToString(record.expenseTotal) : null,
      },
    ],
  },
  {
    title: '총계',
    children: [
      {
        title: '단가',
        dataIndex: 'totalUnitCost',
        width: '8%',
        render: (_, record: any) =>
          record.editable ? priceToString(record.totalUnitCost) : null,
      },
      {
        title: '합계',
        dataIndex: 'total',
        width: '8%',
        render: (_, record: any) =>
          record.editable ? priceToString(record.total) : null,
      },
    ],
  },
];

export const parseChangeOrderSovXlsxFile = async (
  fileData: any,
  projectId: string,
  changeOrderId: number,
) => {
  const wb = read(fileData, { type: 'binary' });
  const sheetNames = wb.SheetNames;
  const results: any = {
    data: [],
    errors: [],
  };

  if (sheetNames.length > 1) {
    Modal.error({
      content: '1개의 시트만 업로드할 수 있습니다.',
    });
    return null;
  }

  for (let i = 0; i < sheetNames.length; i++) {
    const sheet = wb.Sheets[sheetNames[i]];
    sheet['!ref'] = getDataRange(sheet);
    const sheetRows: any[] = utils.sheet_to_json(sheet);

    for (const row of sheetRows) {
      const code = row['코드'];
      // const name = row['품명'];
      // const standard = row['규격'];
      // const unit = row['단위'];
      const name = row['품명'] ? row['품명'] : '';
      const standard = row['규격'] ? row['규격'] : '';
      const unit = row['단위'] ? row['단위'] : '';

      // const quantity = row['수량'];
      // const materialCost = row['재료비 단가'];
      // const laborCost = row['노무비 단가'];
      // const expense = row['경비 단가'];
      const quantity = row['수량'] ? +row['수량'].toFixed(12) : 0;
      // const materialCost = row['재료비 단가'] ? row['재료비 단가'] : 0;
      // const laborCost = row['노무비 단가'] ? row['노무비 단가'] : 0;
      // const expense = row['경비 단가'] ? row['경비 단가'] : 0;
      const materialCost = row['재료비 단가']
        ? row['재료비 단가']
        : row['재료비 금액']
        ? row['재료비 금액'] / row['수량']
        : 0;
      const laborCost = row['노무비 단가'] ? row['노무비 단가'] : 0;
      const expense = row['경비 단가'] ? row['경비 단가'] : 0;

      // if (materialCost === undefined)
      // if (name !== undefined && standard !== undefined && unit !== undefined)

      // const total =
      // (laborCost * quantity) +
      // (materialCost * quantity) +
      // (expense * quantity);
      const total =
        +(laborCost + materialCost + expense).toFixed(12) * quantity;

      let editable = true;
      if (name !== '' && standard === '' && unit === '') editable = false;

      results.data.push({
        project: { id: +projectId },
        changeOrder: { id: +changeOrderId },
        code,
        name,
        standard,
        unit,
        editable,
        quantity,
        materialCost,
        laborCost,
        expense,
        total,
      });
    }
  }

  if (results.data.length === 0) {
    Modal.error({
      content: '업로드 파일의 내용이 없습니다.',
    });
    return null;
  }

  return results.data;
};

export const openKisconPage = (txtSangHo: string, txtCeo: string) => {
  const data: any = {
    hidFlag: 1,
    EP_STATUS: 0,
    hidtxtNum1: '/7Tg5DQJ72nYP2L4AO3KYw==',
    hidtxtNum2: '/7Tg5DQJ72nYP2L4AO3KYw==',
    txtSangHo,
    txtCeo,
  };
  const form = document.createElement('form');
  form.target = '_blank';
  form.method = 'POST';
  form.action = 'https://www.kiscon.net/gongsi/gongsi_list.asp';
  form.style.display = 'none';

  for (const key in data) {
    const input = document.createElement('input');
    input.type = 'hidden';
    input.name = key;
    input.value = data[key];
    form.appendChild(input);
  }

  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

export function phoneFormatter(num: string, type: any) {
  var formatNum = '';

  if (num === null) return formatNum;

  try {
    if (num.length === 11) {
      if (type === 0) {
        formatNum = num.replace(/(\d{3})(\d{4})(\d{4})/, '$1-****-$3');
      } else {
        formatNum = num.replace(/(\d{3})(\d{4})(\d{4})/, '$1-$2-$3');
      }
    } else if (num.length === 8) {
      formatNum = num.replace(/(\d{4})(\d{4})/, '$1-$2');
    } else {
      if (num.indexOf('02') === 0) {
        if (num.length === 9) {
          if (type === 0) {
            formatNum = num.replace(/(\d{2})(\d{3})(\d{4})/, '$1-****-$3');
          } else {
            formatNum = num.replace(/(\d{2})(\d{3})(\d{4})/, '$1-$2-$3');
          }
        } else {
          if (type === 0) {
            formatNum = num.replace(/(\d{2})(\d{4})(\d{4})/, '$1-****-$3');
          } else {
            formatNum = num.replace(/(\d{2})(\d{4})(\d{4})/, '$1-$2-$3');
          }
        }
      } else {
        if (type === 0) {
          formatNum = num.replace(/(\d{3})(\d{3})(\d{4})/, '$1-***-$3');
        } else {
          formatNum = num.replace(/(\d{3})(\d{3})(\d{4})/, '$1-$2-$3');
        }
      }
    }
  } catch (e) {
    formatNum = num;
  }

  return formatNum;
}

export function corporateNumberFormatter(num: string) {
  var formatNum = '';

  if (num === null) return formatNum;

  try {
    formatNum = num.replace(/(\d{3})(\d{2})(\d{5})/, '$1-$2-$3');
  } catch (e) {
    formatNum = num;
  }

  return formatNum;
}

function getLastCharacter(str: string, n: number) {
  let newString = str.substring(str.length - n);
  return newString;
}

export function getExpenseType(expense: Expense) {
  if (expense.insertType === InsertType.DIRECT_INPUT) return '직접입력';
  if (expense.insertType === InsertType.AUTO_RECOG) return '자동인식';
  if (expense.insertType === InsertType.WITH_ASSET_DATA) {
    if (expense.financialAssetInfo.assetType === AssetType.CARD) {
      return `카드(${getLastCharacter(expense.financialAssetInfo.number, 4)})`;
    } else return '세금계산서';
  }
  return '';
}

export function Mobile() {
  return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
    navigator.userAgent,
  );
}

export function maskingRrn(number: string) {
  if (number === undefined || number === '') return '';
  const index = 6;

  const result = number.substring(0, index) + '-' + number.substring(index);
  // console.log(result);

  return result.substring(0, result.length - 6) + '******';
}

export function checkRRN(registNum: string) {
  const regExp = /^\d{2}(0[1-9]|1[0-2])(0[1-9]|[1-2][0-9]|3[0-1])\d{7}$/;
  // const regExp = /^\d{2}(0[1-9]|1[0-2])(0[1-9]|[1-2][0-9]|3[0-1])[-]\d{7}$/;

  if (registNum === undefined || registNum === '') return Promise.resolve();

  if (regExp.test(registNum)) {
    return Promise.resolve();
  }
  return Promise.reject(new Error('유효하지 않은 주민등록번호 입니다.'));
}

export const timeForToday = (value: string) => {
  const today = new Date();
  const timeValue = new Date(value);

  const betweenTime = Math.floor(
    (today.getTime() - timeValue.getTime()) / 1000 / 60,
  );
  if (betweenTime < 1) return '방금 전';
  if (betweenTime < 60) {
    return `${betweenTime}분 전`;
  }

  const betweenTimeHour = Math.floor(betweenTime / 60);
  if (betweenTimeHour < 24) {
    return `${betweenTimeHour}시간 전`;
  }

  const betweenTimeDay = Math.floor(betweenTime / 60 / 24);
  if (betweenTimeDay < 365) {
    return `${betweenTimeDay}일 전`;
  }

  return `${Math.floor(betweenTimeDay / 365)}년 전`;
};

export const checkRateFixedPointStr = (value: any) => {
  if (isNaN(value)) return '';
  if (!isFinite(value)) return '';
  return (value * 100).toFixed(2) + '%';
};

export const normFile = (e: any) => {
  let fileList = e.fileList;
  if (Array.isArray(e)) {
    return e;
  }
  return e && fileList;
};
